"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("@emotion/react/jsx-runtime");
var react_1 = __importStar(require("react"));
var material_1 = require("@mui/material");
var StepConnector_1 = __importStar(require("@mui/material/StepConnector"));
require("react-quill/dist/quill.snow.css");
var Close_1 = __importDefault(require("@mui/icons-material/Close"));
var styled_1 = __importDefault(require("@emotion/styled"));
var react_google_recaptcha_v3_1 = require("react-google-recaptcha-v3");
var ApplyVacancyContext_1 = __importDefault(require("../../context/ApplyVacancyContext"));
var ApplyForm_1 = __importDefault(require("./ApplyForm"));
var RegisterForm_1 = __importDefault(require("./RegisterForm"));
var ConfirmAccountBlock_1 = __importDefault(require("./ConfirmAccountBlock"));
var ApplyDialogStyles_1 = require("./ApplyDialogStyles");
var useIsSmallScreen_1 = __importDefault(require("../../hooks/useIsSmallScreen"));
var UserContext_1 = __importDefault(require("../../context/UserContext"));
var Connector = (0, styled_1.default)(StepConnector_1.default)(function () {
    var _a;
    return (_a = {},
        _a["& .".concat(StepConnector_1.stepConnectorClasses.line)] = {
            borderColor: 'black',
            borderTopWidth: 2,
            borderBottomWidth: 0,
            borderBlockStyle: 'dashed',
        },
        _a);
});
var ApplyDialog = function (_a) {
    var vacancy = _a.vacancy;
    var userId = (0, react_1.useContext)(UserContext_1.default).userId;
    var _b = (0, react_1.useContext)(ApplyVacancyContext_1.default), openApplyVacancy = _b.openApplyVacancy, handleOpenApplyVacancy = _b.handleOpenApplyVacancy;
    var _c = (0, react_1.useState)(0), activeStep = _c[0], setActiveStep = _c[1];
    var isSmallScreen = (0, useIsSmallScreen_1.default)();
    var steps = (0, react_1.useMemo)(function () {
        if (userId) {
            return [];
        }
        return ['motivation', 'registration'];
    }, [userId]);
    var handleSetActiveStep = function (index) {
        if (activeStep === 1) {
            setActiveStep(index);
        }
    };
    return ((0, jsx_runtime_1.jsx)(react_google_recaptcha_v3_1.GoogleReCaptchaProvider, __assign({ reCaptchaKey: process.env.MIX_CAPTCHA_SITE_KEY }, { children: (0, jsx_runtime_1.jsxs)(material_1.Dialog, __assign({ sx: { '& > .MuiDialog-container': { justifyContent: 'flex-end' }, '&.MuiDialog-root': { top: { xs: '50px', md: '0' } } }, PaperProps: { sx: __assign({}, ApplyDialogStyles_1.formBlockStyles.dialogPaper) }, fullScreen: true, open: openApplyVacancy, onClose: function () { return handleOpenApplyVacancy(false); } }, { children: [isSmallScreen === false && ((0, jsx_runtime_1.jsx)(material_1.IconButton, __assign({ size: "medium", sx: ApplyDialogStyles_1.formBlockStyles.closeButton, onClick: function () { return handleOpenApplyVacancy(false); } }, { children: (0, jsx_runtime_1.jsx)(Close_1.default, {}) }))), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ flexBasis: "100%", flexGrow: "1", overflow: "auto" }, { children: [(0, jsx_runtime_1.jsx)(material_1.Box, __assign({ display: userId ? 'none' : 'flex', sx: __assign(__assign({}, ApplyDialogStyles_1.formBlockStyles.paddingSpace), { pt: 8 }) }, { children: (0, jsx_runtime_1.jsx)(material_1.Stepper, __assign({ nonLinear: true, activeStep: activeStep, connector: (0, jsx_runtime_1.jsx)(Connector, {}), sx: { width: { xs: '100%', md: '240px' } } }, { children: steps.map(function (label, index) {
                                    return ((0, jsx_runtime_1.jsx)(material_1.Step, __assign({ onClick: function () { return handleSetActiveStep(index); } }, { children: (0, jsx_runtime_1.jsx)(material_1.StepLabel, __assign({ StepIconProps: { sx: { fontSize: '2em', '&.Mui-active': { color: 'secondary.main' } } } }, { children: " " })) }), label));
                                }) })) })), (0, jsx_runtime_1.jsx)(material_1.Box, __assign({ sx: ApplyDialogStyles_1.formBlockStyles.titleBox }, { children: (0, jsx_runtime_1.jsx)(material_1.Typography, __assign({ fontWeight: "bold", variant: "h4" }, { children: vacancy.title })) })), (0, jsx_runtime_1.jsx)(ApplyForm_1.default, { vacancy: vacancy, setActiveStep: setActiveStep, activeStep: activeStep }), (0, jsx_runtime_1.jsx)(RegisterForm_1.default, { activeStep: activeStep })] })), activeStep === 1 && isSmallScreen === false && (0, jsx_runtime_1.jsx)(ConfirmAccountBlock_1.default, {})] })) })));
};
exports.default = ApplyDialog;
